import { useQuery } from "react-query"
import { get_job_seeker_detail } from "../../services/approvals";


const useJobSeekerDetail = (id) => {
    return useQuery('get_job_seeker_detail', ()=>get_job_seeker_detail(id))
}

export default useJobSeekerDetail;